// extracted by mini-css-extract-plugin
export default {"strategyCard":"StrategyCard_strategyCard__yZ2oP"};